/* eslint-disable no-console */
const FINGERPRINT_STORAGE_KEY = 'deviceFingerprintCaptured';
const STORAGE_EXPIRY_HOURS = 24; // Expire after 24 hours

interface FingerprintStorage {
  captured: boolean;
  timestamp: number;
}

export const setFingerprintCaptured = (): void => {
  if (typeof window === 'undefined') return;
  const data: FingerprintStorage = {
    captured: true,
    timestamp: Date.now(),
  };

  localStorage.setItem(FINGERPRINT_STORAGE_KEY, JSON.stringify(data));
};

export const isFingerprintCaptured = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    const stored = localStorage.getItem(FINGERPRINT_STORAGE_KEY);
    if (!stored) return false;

    const data: FingerprintStorage = JSON.parse(stored);
    const expiryTime = data.timestamp + (STORAGE_EXPIRY_HOURS * 60 * 60 * 1000);

    // Check if expired
    if (Date.now() > expiryTime) {
      localStorage.removeItem(FINGERPRINT_STORAGE_KEY);
      return false;
    }

    return data.captured;
  } catch {
    console.log('isFingerprintCaptured error');
    // If there's any error parsing, consider it not captured
    localStorage.removeItem(FINGERPRINT_STORAGE_KEY);
    return false;
  }
};

export const clearFingerprintCaptured = (): void => {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(FINGERPRINT_STORAGE_KEY);
};
